/**
 * Карточка ссылки-приглашения (03.10, владелец: «доступ новому — одноразовой ссылкой
 * в STAFF-бота, 72 часа, одно использование, новая ссылка отзывает прежнюю»).
 * Ссылка (тап — копировать), «Копировать», «Отправить» (окно Telegram «Поделиться»),
 * статус «ждём привязки / привязан» и «Новая ссылка». Пока вход не привязан, раз
 * в 8 с тихо перечитываем ростер (onPoll) — статус сменится сам, без «обновить»;
 * через 10 минут опрос останавливается. После привязки кнопки прячутся.
 */
import { useEffect, useRef, useState } from "react";
import type { Invite } from "../../hooks/staffApi";
import { copyText } from "../../lib/clipboard";
import { openTgShare } from "../../lib/telegram";
import css from "./invite.module.css";

const POLL_MS = 8000;
const POLL_FOR_MS = 10 * 60_000;

function untilLabel(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  const p = (n: number) => String(n).padStart(2, "0");
  return `до ${p(d.getDate())}.${p(d.getMonth() + 1)} ${p(d.getHours())}:${p(d.getMinutes())}`;
}

export function InviteCard({ invite, name, bound, busy, onNew, onPoll }: {
  invite: Invite;
  name: string;
  bound: boolean;
  busy?: boolean;
  onNew: () => void;
  onPoll?: () => void;
}) {
  const [flash, setFlash] = useState<string | null>(null);
  const pollRef = useRef(onPoll);
  pollRef.current = onPoll;
  const t = useRef(0);
  useEffect(() => () => window.clearTimeout(t.current), []);
  useEffect(() => {
    if (bound) return;
    const started = Date.now();
    const iv = window.setInterval(() => {
      if (Date.now() - started > POLL_FOR_MS) { window.clearInterval(iv); return; }
      pollRef.current?.();
    }, POLL_MS);
    return () => window.clearInterval(iv);
  }, [bound, invite.url]);

  const say = (s: string) => { setFlash(s); window.clearTimeout(t.current); t.current = window.setTimeout(() => setFlash(null), 1800); };
  const copy = async () => { if (invite.url) say((await copyText(invite.url)) ? "Скопировано" : "Не скопировалось"); };
  /* 03.10 (ревью): t.me/share кладёт ссылку ПЕРВОЙ, текст — под ней: без двоеточия «в никуда» и без «откройте в Telegram» */
  const share = () => { if (invite.url) openTgShare(invite.url, `${name}, это ваша ссылка для входа в кабинет UniBooking. Нажмите её, затем «Запустить» в боте — доступ откроется. Ссылка одноразовая, действует 72 часа.`); };

  return (
    <div className={`${css.card} ${bound ? css.bound : ""}`}>
      <div className={css.head}>
        <span className={css.title}>Ссылка для входа</span>
        <span className={`${css.st} ${bound ? css.stOk : css.stWait}`}>
          <i className={css.pulse} />{bound ? "привязан" : "ждём привязки"}
        </span>
      </div>
      {bound ? (
        <div className={css.meta}>Ссылка открыта — вход в кабинет работает.</div>
      ) : invite.url ? (
        <>
          <button type="button" className={css.url} onClick={() => void copy()} title="Скопировать">{invite.url}</button>
          <div className={css.meta}>{flash ?? `Одноразовая, ${untilLabel(invite.expiresAt)}`}</div>
          <div className={css.btns}>
            <button type="button" className={css.btn} onClick={() => void copy()}>Копировать</button>
            <button type="button" className={`${css.btn} ${css.btnGo}`} onClick={share}>Отправить</button>
            <button type="button" className={css.btn} disabled={busy} onClick={onNew}>{busy ? "…" : "Новая ссылка"}</button>
          </div>
        </>
      ) : (
        <>
          <div className={css.warn}>Ссылку собрать не удалось: сервер не узнал имя бота. Попробуйте «Новая ссылка» чуть позже.</div>
          <div className={css.btns}>
            <button type="button" className={css.btn} disabled={busy} onClick={onNew}>{busy ? "…" : "Новая ссылка"}</button>
          </div>
        </>
      )}
    </div>
  );
}
